import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const PLAN_NAMES = { starter:'Starter', landlord:'Landlord', portfolio:'Portfolio' };

export default function BillingBlocker({ plan = 'starter', autoRedirect = false }) {
  const { user }    = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  useEffect(() => {
    if (autoRedirect) handleSetupBilling();
  }, []);

  async function handleSetupBilling() {
    setLoading(true); setError('');
    try {
      const res = await fetch('/api/billing/create-trial-checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({ plan }),
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
      else throw new Error('Could not create checkout session');
    } catch (err) {
      setError(err.message);
    } finally { setLoading(false); }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)',
      padding: 24,
    }}>
      <div style={{
        background: 'var(--card)',
        border: '1.5px solid var(--border)',
        borderRadius: 16,
        padding: '48px 40px',
        maxWidth: 440,
        width: '100%',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 40, marginBottom: 16 }}>🔒</div>
        <h2 style={{ fontSize: 24, fontWeight: 300, marginBottom: 8 }}>
          Complete your setup
        </h2>
        <p style={{ fontSize: 14, color: 'var(--ink-3)', marginBottom: 8 }}>
          Hi {user?.full_name?.split(' ')[0] || 'there'} — you're one step away from full access.
        </p>
        <p style={{ fontSize: 14, color: 'var(--ink-3)', marginBottom: 32 }}>
          Set up billing to start your <strong>14-day free trial</strong> on the {PLAN_NAMES[plan]} plan.
          No charge until your trial ends — cancel anytime.
        </p>

        <button
          onClick={handleSetupBilling}
          disabled={loading}
          style={{
            width: '100%',
            padding: '14px',
            background: 'var(--ink)',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontSize: 16,
            cursor: loading ? 'wait' : 'pointer',
            opacity: loading ? 0.7 : 1,
            marginBottom: 12,
          }}
        >
          {loading ? 'Loading…' : 'Set up billing & start trial →'}
        </button>

        {error && <p style={{ fontSize: 13, color: 'var(--danger)', marginTop: 8 }}>{error}</p>}

        <p style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 16 }}>
          🔒 Secured by Stripe · Cancel anytime in your billing portal
        </p>
      </div>
    </div>
  );
}